export default "/images/solana_environment__icon.png";